/**
 * @param {object} d - Demographics (or merge) with rawAddress, address (street), city, state, zip
 */
export function hasCompleteAddress(d) {
  if (!d) return false;
  const line = (d.rawAddress || "").trim();
  if (line.length >= 8) return true;
  const street = (d.address || d.street || "").trim();
  const city = (d.city || "").trim();
  const state = (d.state || "").trim();
  const zip = (d.zip || "").trim();
  if (street && city && state && zip && zip.length >= 5) return true;
  if (street && city && state) return true;
  return false;
}
